/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sandboxes_Latestchangesbutton2Inputs */

const id_sandboxes_latestchangesbutton2 = /** @type {(inputs: Sandboxes_Latestchangesbutton2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Perubahan terbaru`)
};

const ms_sandboxes_latestchangesbutton2 = /** @type {(inputs: Sandboxes_Latestchangesbutton2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Perubahan terkini`)
};

const da_sandboxes_latestchangesbutton2 = /** @type {(inputs: Sandboxes_Latestchangesbutton2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seneste ændringer`)
};

const de_sandboxes_latestchangesbutton2 = /** @type {(inputs: Sandboxes_Latestchangesbutton2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Letzte Änderungen`)
};

const en_us2_sandboxes_latestchangesbutton2 = /** @type {(inputs: Sandboxes_Latestchangesbutton2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Latest changes`)
};

const es_es2_sandboxes_latestchangesbutton2 = /** @type {(inputs: Sandboxes_Latestchangesbutton2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Últimos cambios`)
};

const es_mx2_sandboxes_latestchangesbutton2 = /** @type {(inputs: Sandboxes_Latestchangesbutton2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Últimos cambios`)
};

const fil_sandboxes_latestchangesbutton2 = /** @type {(inputs: Sandboxes_Latestchangesbutton2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mga pinakabagong pagbabago`)
};

const fr_sandboxes_latestchangesbutton2 = /** @type {(inputs: Sandboxes_Latestchangesbutton2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dernières modifications`)
};

const it_sandboxes_latestchangesbutton2 = /** @type {(inputs: Sandboxes_Latestchangesbutton2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ultime modifiche`)
};

const hu_sandboxes_latestchangesbutton2 = /** @type {(inputs: Sandboxes_Latestchangesbutton2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Legutóbbi változások`)
};

const nl_sandboxes_latestchangesbutton2 = /** @type {(inputs: Sandboxes_Latestchangesbutton2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Laatste wijzigingen`)
};

const no_sandboxes_latestchangesbutton2 = /** @type {(inputs: Sandboxes_Latestchangesbutton2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Siste endringer`)
};

const pl_sandboxes_latestchangesbutton2 = /** @type {(inputs: Sandboxes_Latestchangesbutton2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ostatnie zmiany`)
};

const pt_br2_sandboxes_latestchangesbutton2 = /** @type {(inputs: Sandboxes_Latestchangesbutton2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Últimas alterações`)
};

const pt_sandboxes_latestchangesbutton2 = /** @type {(inputs: Sandboxes_Latestchangesbutton2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Últimas alterações`)
};

const ro_sandboxes_latestchangesbutton2 = /** @type {(inputs: Sandboxes_Latestchangesbutton2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ultimele modificări`)
};

const fi_sandboxes_latestchangesbutton2 = /** @type {(inputs: Sandboxes_Latestchangesbutton2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Viimeisimmät muutokset`)
};

const sv_sandboxes_latestchangesbutton2 = /** @type {(inputs: Sandboxes_Latestchangesbutton2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Senaste ändringarna`)
};

const vi_sandboxes_latestchangesbutton2 = /** @type {(inputs: Sandboxes_Latestchangesbutton2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thay đổi mới nhất`)
};

const tr_sandboxes_latestchangesbutton2 = /** @type {(inputs: Sandboxes_Latestchangesbutton2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Son değişiklikler`)
};

const cs_sandboxes_latestchangesbutton2 = /** @type {(inputs: Sandboxes_Latestchangesbutton2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Poslední změny`)
};

const bg_sandboxes_latestchangesbutton2 = /** @type {(inputs: Sandboxes_Latestchangesbutton2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Последни промени`)
};

const ru_sandboxes_latestchangesbutton2 = /** @type {(inputs: Sandboxes_Latestchangesbutton2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Последние изменения`)
};

const uk_sandboxes_latestchangesbutton2 = /** @type {(inputs: Sandboxes_Latestchangesbutton2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Останні зміни`)
};

const ar_sandboxes_latestchangesbutton2 = /** @type {(inputs: Sandboxes_Latestchangesbutton2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`أحدث التغييرات`)
};

const hi_sandboxes_latestchangesbutton2 = /** @type {(inputs: Sandboxes_Latestchangesbutton2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`नवीनतम परिवर्तन`)
};

const th_sandboxes_latestchangesbutton2 = /** @type {(inputs: Sandboxes_Latestchangesbutton2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`การเปลี่ยนแปลงล่าสุด`)
};

const ja_sandboxes_latestchangesbutton2 = /** @type {(inputs: Sandboxes_Latestchangesbutton2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`最新の変更`)
};

const zh_cn2_sandboxes_latestchangesbutton2 = /** @type {(inputs: Sandboxes_Latestchangesbutton2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`最新更改`)
};

const zh_hant1_sandboxes_latestchangesbutton2 = /** @type {(inputs: Sandboxes_Latestchangesbutton2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`最新變更`)
};

const ko_sandboxes_latestchangesbutton2 = /** @type {(inputs: Sandboxes_Latestchangesbutton2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`최근 변경 사항`)
};

/**
* | output |
* | --- |
* | "Latest changes" |
*
* @param {Sandboxes_Latestchangesbutton2Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const sandboxes_latestchangesbutton2 = /** @type {((inputs?: Sandboxes_Latestchangesbutton2Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sandboxes_Latestchangesbutton2Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_sandboxes_latestchangesbutton2(inputs)
	if (locale === "ms") return ms_sandboxes_latestchangesbutton2(inputs)
	if (locale === "da") return da_sandboxes_latestchangesbutton2(inputs)
	if (locale === "de") return de_sandboxes_latestchangesbutton2(inputs)
	if (locale === "en-US") return en_us2_sandboxes_latestchangesbutton2(inputs)
	if (locale === "es-ES") return es_es2_sandboxes_latestchangesbutton2(inputs)
	if (locale === "es-MX") return es_mx2_sandboxes_latestchangesbutton2(inputs)
	if (locale === "fil") return fil_sandboxes_latestchangesbutton2(inputs)
	if (locale === "fr") return fr_sandboxes_latestchangesbutton2(inputs)
	if (locale === "it") return it_sandboxes_latestchangesbutton2(inputs)
	if (locale === "hu") return hu_sandboxes_latestchangesbutton2(inputs)
	if (locale === "nl") return nl_sandboxes_latestchangesbutton2(inputs)
	if (locale === "no") return no_sandboxes_latestchangesbutton2(inputs)
	if (locale === "pl") return pl_sandboxes_latestchangesbutton2(inputs)
	if (locale === "pt-BR") return pt_br2_sandboxes_latestchangesbutton2(inputs)
	if (locale === "pt") return pt_sandboxes_latestchangesbutton2(inputs)
	if (locale === "ro") return ro_sandboxes_latestchangesbutton2(inputs)
	if (locale === "fi") return fi_sandboxes_latestchangesbutton2(inputs)
	if (locale === "sv") return sv_sandboxes_latestchangesbutton2(inputs)
	if (locale === "vi") return vi_sandboxes_latestchangesbutton2(inputs)
	if (locale === "tr") return tr_sandboxes_latestchangesbutton2(inputs)
	if (locale === "cs") return cs_sandboxes_latestchangesbutton2(inputs)
	if (locale === "bg") return bg_sandboxes_latestchangesbutton2(inputs)
	if (locale === "ru") return ru_sandboxes_latestchangesbutton2(inputs)
	if (locale === "uk") return uk_sandboxes_latestchangesbutton2(inputs)
	if (locale === "ar") return ar_sandboxes_latestchangesbutton2(inputs)
	if (locale === "hi") return hi_sandboxes_latestchangesbutton2(inputs)
	if (locale === "th") return th_sandboxes_latestchangesbutton2(inputs)
	if (locale === "ja") return ja_sandboxes_latestchangesbutton2(inputs)
	if (locale === "zh-CN") return zh_cn2_sandboxes_latestchangesbutton2(inputs)
	if (locale === "zh-Hant") return zh_hant1_sandboxes_latestchangesbutton2(inputs)
	return ko_sandboxes_latestchangesbutton2(inputs)
});
export { sandboxes_latestchangesbutton2 as "sandboxes.latestChangesButton" }